import { MarkNotificationAsReadRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'

// notification_id is sourced from the route via validationData(), not the request body.
export const NotificationInboxMarkAsRead = (_context: NoContext) =>
  MarkNotificationAsReadRequestSchema
